// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { BookingState, GetBookingsParams } from "@/types/admin/booking-type";
// import { bookingService } from "@/services/system-admin/admin-data.service";

// const initialState: BookingState = {
//   bookings: [],
//   loading: false,
//   error: null,
//   totalCount: 0,
//   currentPage: 1,
//   pageSize: 20,
// };

// export const fetchBookings = createAsyncThunk(
//   "bookings/fetchBookings",
//   async (params: GetBookingsParams) => {
//     const response = await bookingService.getBookings(params);
//     return { ...response, page: params.page, pageSize: params.pageSize };
//   }
// );

// const bookingSlice = createSlice({
//   name: "bookings",
//   initialState,
//   reducers: {
//     clearError: (state) => { state.error = null; },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchBookings.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchBookings.fulfilled, (state, action) => {
//         state.loading = false;
//         const list = action.payload.items || action.payload.data || action.payload.result?.items || [];
//         state.bookings = list;
//         state.currentPage = action.payload.page || 1;
//         state.pageSize = action.payload.pageSize || 20;
//         if (list.length > 0) {
//           state.totalCount = list[0].totalCount || action.payload.totalCount || action.payload.result?.totalCount || 0;
//         } else {
//           state.totalCount = action.payload.totalCount || action.payload.result?.totalCount || 0;
//         }
//       })
//       .addCase(fetchBookings.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || "Failed to fetch bookings";
//       });
//   },
// });

// export const { clearError } = bookingSlice.actions;
// export default bookingSlice.reducer;
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BookingState, GetBookingsParams } from "@/types/admin/booking-type";
import { bookingService } from "@/services/system-admin/admin-data.service";

const initialState: BookingState = {
  bookings: [],
  loading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
};

export const fetchBookings = createAsyncThunk(
  "adminBookings/fetchBookings",
  async (params: GetBookingsParams) => {
    const response = await bookingService.getBookings(params);
    return { ...response, page: params.page, pageSize: params.pageSize };
  }
);

const bookingSlice = createSlice({
  name: "adminBookings",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookings.fulfilled, (state, action) => {
        state.loading = false;
        // Real shape: { result: { items: [...], paging: { total: 228 } } }
        const items = action.payload.result?.items || [];
        state.bookings = items;
        state.totalCount = action.payload.result?.paging?.total || 0;
        state.currentPage = action.payload.page || 1;
        state.pageSize = action.payload.pageSize || 10;
      })
      .addCase(fetchBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch bookings";
      });
  },
});

export const { clearError } = bookingSlice.actions;
export default bookingSlice.reducer;